import Title from "../home/Title";
import {
  projectImgWdOne,
  projectImgWdTwo,
  projectImgWsOne,
  projectImgWsTwo,
  projectImgMlOne,
  projectImgMlTwo,
  projectImgAiOne,
  projectImgAiTwo,
  projectImgDataOne,
  projectImgDataTwo,
  projectImgOtherOne,
  projectImgOtherTwo,
  projectImgFyp,
  projectImgAdOne,
  projectImgAdTwo,
  projectImgWdThree,
  projectImgWdFour,
  projectImgWdFive,
  projectImgWdSix,
  projectImgFeaturedOne,
} from "../../assets";
import ResumeTitle from "../resume/ResumeTitle";
import {
  FaGithub,
  FaHtml5,
  FaCss3,
  FaJs,
  FaPython,
  FaNodeJs,
  FaReact,
  FaPepperHot,
} from "react-icons/fa6";
import { BiLogoGoogleCloud, BiLogoPlayStore } from "react-icons/bi";
import { TbApi, TbBrandNextjs } from "react-icons/tb";
import {
  SiPowerbi,
  SiDialogflow,
  SiFirebase,
  SiTypescript,
  SiTailwindcss,
  SiMongodb,
  SiNestjs,
  SiStripe,
} from "react-icons/si";
import { FaSafari } from "react-icons/fa";
import { IoLogoAppleAppstore } from "react-icons/io5";
import { LuBrainCircuit } from "react-icons/lu";

const Projects = () => {
  return (
    <div>
      <Title title="My" subTitle="Projects" />
      <ResumeTitle title="Featured Projects" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 lgl:gap-x-10">
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgFeaturedOne}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                YOLOv8 Object Tracking
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Real-time object detection and tracking system for videos and images using advanced computer vision techniques with YOLOv8
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-md" />, YOLOv8
                  <LuBrainCircuit className="text-md" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://drive.google.com/file/d/1O4R-MP4fNzh1cfB2KUeY4jz1cSIndOqk/view?usp=sharing' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/yolov8-object-tracking' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgFyp}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Sign Language App (FYP)
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Two-way sign language recognition system using React Native, CNN and Flask to help deaf community communication
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  React Native
                  <FaReact className="text-md" />, Flask
                  <FaPepperHot className="text-md" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://drive.google.com/file/d/1-_GhAk4OLxrVAdM_mUitRqy9juPftosq/view?usp=sharing' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/SignLanguageProject' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t-[1px] border-t-zinc-800">
        <ResumeTitle title="Web Development" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 lgl:gap-x-10">
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgWdFive}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                H&S Real Estate
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Developed H&S Real Estate website using Next.js with Bayut API for real-time listings and advanced search.
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Next Js
                  <TbBrandNextjs className="text-md" />& Bayut API
                  <TbApi className="text-lg" />
                </div>
                <div class="w-full pt-4 flex justify-between items-center ">
                  <a href='https://hsproperty.ae/' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgWdSix}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Zip Holiday
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Developed Zip Holiday website using Next.js with Duffel and HotelBeds APIs for seamless travel bookings.
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Next Js
                  <TbBrandNextjs className="text-md" />& HotelBeds & Duffel API
                  <TbApi className="text-lg" />
                </div>
                <div class="w-full pt-4 flex justify-between items-center ">
                  <a href='https://www.zipholiday.com/' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgWdOne}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Twitter(X) Clone
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Designing a MERN Twitter clone involves intuitive UI, responsive design, accessibility, and user-centered optimizations
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  React.js
                  <FaReact className="text-md" />, Node.js
                  <FaNodeJs className="text-md" />& MongoDB
                  <SiMongodb className="text-md" />
                </div>
                <div class="w-full pt-4 flex justify-between items-center ">
                  <a href='https://twitter-clone-2wzq.onrender.com' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/twitter-clone' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgWdTwo}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Bazar
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Creating a React Firebase shopping site comprises user-friendly UI and seamless payment experience with Stripe
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  React.js
                  <FaReact className="text-md" />, Firebase
                  <SiFirebase className="text-md" />& Tailwind CSS
                  <SiTailwindcss className="text-md" />
                </div>
                <div class="w-full pt-4 flex justify-between items-center ">
                  <a href='https://bazar-beryl.vercel.app/' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/bazar' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgWdThree}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                CarHub
              </h2>
              <p className="text-xs -mt-1 text-gray-400">
                Developing a Next JS, Rapid Car API CarHub website where you find, book, rent a car quickly ensuring seamless experience
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Next.js
                  <TbBrandNextjs className="text-lg" />, TypeScript
                  <SiTypescript className="text-md" />& Rapid API
                  <TbApi className="text-lg" />
                </div>
                <div class="w-full pt-4 flex justify-between items-center ">
                  <a href='https://carhub-five-theta.vercel.app/' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/carhub' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgWdFour}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Omnifood
              </h2>
              <p className="text-xs -mt-1 text-gray-400">
                Developing an Omnifood website for seamlessly delivering healthy, tasty and hassle-free meals to your door, every single day
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  HTML
                  <FaHtml5 className="text-md" />, CSS
                  <FaCss3 className="text-md" />& JavaScript
                  <FaJs className="text-md" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://omnifood-henna.vercel.app/' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/Omnifood' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t-[1px] border-t-zinc-800">
        <ResumeTitle title="App Development" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgAdOne}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Bark Media
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">Developed Bark Media, a React Native music app integrating SoundCloud API, playlists, and secure Stripe payments.</p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div class="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span class="w-4 h-px mr-1 bg-gray-400"></span>React Native<FaReact className="text-md" />, Stripe<SiStripe className="text-md" />& Nest Js <SiNestjs className="text-md" />
                </div>

                <div class="w-full pt-4 flex justify-between items-center ">
                  <a href='https://apps.apple.com/us/app/bark-media/id6747454337' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><IoLogoAppleAppstore className="text-lg" />App Store </a>
                  <a href='https://play.google.com/store/apps/details?id=com.barkmedia.musicapp' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><BiLogoPlayStore className="text-lg" />Play Store</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgAdTwo}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Dream Destination
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">Dream destination app have destinations categorized by interest, finding travel buddy and many more</p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div class="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span class="w-4 h-px mr-1 bg-gray-400"></span>React Native<FaReact className="text-md" />& Firebase <SiFirebase className="text-md" />
                </div>

                <div class="w-full pt-4 flex justify-between items-center ">
                  <a href='https://drive.google.com/file/d/10IDB91PcY8UUskBZ9p9PV45CZ1DlNfW2/view?usp=sharing' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/Dream-Destination' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t-[1px] border-t-zinc-800">
        <ResumeTitle title="Machine Learning" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgMlOne}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Digital Meter Text Extraction
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Utilizing CNN for precise text extraction from digital meters, enhancing data retrieval and analysis in utilities
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-lg" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://colab.research.google.com/drive/1ekOqQyURzLWVaV8pzCv03-ChXUT6Nupq?usp=sharing' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/Digital-Meter-Text-Extraction' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgMlTwo}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Stock Price Prediction
              </h2>
              <p className="text-xs -mt-1 text-gray-400">
                Creating LSTM model for accurate stock price predictions, aiding investors in informed decision-making and risk management
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-lg" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://colab.research.google.com/drive/1CCEZj1jdKwYSFGInGR4UzQm0ZkbEh5x9?usp=sharing' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/Stock-Price-Prediction' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t-[1px] border-t-zinc-800">
        <ResumeTitle title="Artificial Intelligence" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgAiOne}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Speech To Text
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Implementing Google Speech to Text API for accurate and efficient speech-to-text conversion in diverse applications
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-lg" />& Google Cloud API
                  <BiLogoGoogleCloud className="text-lg" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://colab.research.google.com/drive/1h7hO3h3SsbyumD4AXxZ1AymHPH_p6UFy?usp=sharing' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/Speech-To-Text' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgAiTwo}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Emotion Detection
              </h2>
              <p className="text-xs -mt-1 text-gray-400">
                Developing a robust SVM AI system for emotion detection, improving user experience and emotional analysis accuracy
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-lg" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://colab.research.google.com/drive/180E8AUsTqEy2M9CYWKGcqwlyv2stdar7?usp=sharing' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/Emotion-Detection' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t-[1px] border-t-zinc-800">
        <ResumeTitle title="Data Mining & Web Scraping" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300 "
                src={projectImgWsOne}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Gsmarena.com Scraping
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Scraped GSMarena.com for mobile specs, parsed data, and analyzed trends in mobile devices for comprehensive insights
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-lg" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://docs.google.com/spreadsheets/d/1X3JkRbU5YbfJEgZdv89mGAIenF_qfY61h-Y4OanIX_s/edit?usp=sharing' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/Gsmarena-Scraping' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300 "
                src={projectImgWsTwo}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Alkaramstudio.com Scraping
              </h2>
              <p className="text-xs -mt-1 text-gray-400">
                Scraped Alkaramstudio.com for clothes details, parsed data, and analyzed trends in clothes for comprehensive insights
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-lg" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://docs.google.com/spreadsheets/d/1h2xcCdS0vlCjbGcFmGJZhVC_Jhv6a2rYIhldxBVWIJA/edit?usp=sharing' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/AlkaramStudio-Scraping' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t-[1px] border-t-zinc-800">
        <ResumeTitle title="Data Analysis" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgDataOne}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Adventureworks Sales Analysis
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                Analyzing AdventureWorks sales data with Power BI for insightful business intelligence and data-driven decisions
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Power BI
                  <SiPowerbi className="text-lg" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://drive.google.com/file/d/1IeVH3m5eCKM5lvBUU8Bx8eHLNJra9gZz/view?usp=sharing' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/Adventureworks-Sales-Analysis' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgDataTwo}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                NBA Records EDA
              </h2>
              <p className="text-xs -mt-1 text-gray-400">
                Exploratory Data Analysis (EDA) of NBA records, extracting insights for data-driven basketball strategies and decisions
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-lg" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://colab.research.google.com/drive/1wIjTaBG6KPL2iu9WduNbU73sNEV2Mfuo' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/NBA-Records-EDA' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t-[1px] border-t-zinc-800">
        <ResumeTitle title="Others" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgOtherOne}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                GSM Arena Q&A
              </h2>
              <p className="text-xs -mt-1 text-gray-400 ">
                GSM Arena Q&A system using their data to assist users with mobile specs inquiries using Google DialogFlow
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-lg" />, Node.js
                  <FaNodeJs className="text-md" />& Dialogflow
                  <SiDialogflow className="text-lg" />
                </div>
                <div className="w-full pt-4 flex justify-between items-center ">
                  <a href='https://www.linkedin.com/posts/zakawat-abbas_data-cloud-google-activity-6975862235000659968-QXZZ?utm_source=combined_share_message&utm_medium=member_desktop' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/GSMareana-QA' target="_blank" rel="noreferrer" className=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6 ">
          <div className="py-6 flex flex-col gap-2 items-center justify-center group">
            <div className="w-full h-full mb-2 overflow-hidden relative rounded-lg">
              <img
                className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300"
                src={projectImgOtherTwo}
                alt="blogImgOne"
              />
            </div>
            <div className="flex flex-col items-center gap-2">
              <h2 className="text-base text-center font-semibold font-titleFont text-designColor">
                Alkaram Studio Chatbot
              </h2>
              <p className="text-xs -mt-1 text-gray-400">
                Chatbot created for Alkaram Studio to provide customer support and product information using Google DialogFlow
              </p>
              <div className="w-full flex flex-col gap-4 px-2 mt-3">
                <div className="text-xs text-gray-500 flex flex-wrap items-center gap-1">
                  <span className="w-4 h-px mr-1 bg-gray-400"></span>
                  Python
                  <FaPython className="text-lg" />, Node.js
                  <FaNodeJs className="text-md" />& Dialogflow
                  <SiDialogflow className="text-lg" />
                </div>
                <div class="w-full pt-4 flex justify-between items-center ">
                  <a href='https://www.linkedin.com/posts/zakawat-abbas_data-cloud-google-activity-7068658329748652032-cMOZ?utm_source=combined_share_message&utm_medium=member_desktop' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center"><FaSafari className="text-lg" />Demo</a>
                  <a href='https://github.com/Zakawat-Abbas/Alkaram-Chatbot' target="_blank" rel="noreferrer" class=" bg-gray-200 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 mr-2 mb-2 flex gap-1 items-center "><FaGithub className="text-lg" />Code</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
